import { gql } from '@apollo/client';

export const DELETE_WALLET_TOKEN_BY_TOKEN_ID = gql`
  mutation deleteWalletTokenByTokenId($walletId: String!) {
    deleteWalletTokenByTokenId(walletId: $walletId)
  }
`;
